import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import Button from '../Button';
import SecondaryButton from '../SecondaryButton';
import styles from './PromptModal.css';
import { okPromptAction, cancelPromptAction } from '../../redux/prompt';
import UpgradeUserMessage from './UpgradeUserMessage';
import RemoveUserMessage from './RemoveUserMessage';
import FormError from '../Forms/FormError';
import getUniqueId from '../../utils/getUniqueId';

const messages = {
  'upgrade-user': UpgradeUserMessage,
  'remove-user': RemoveUserMessage,
};

export const PromptModal = ({
  open,
  message,
  props,
  okButton,
  cancelButton,
  title,
  cancelPrompt,
  okPrompt,
  primary,
  loading,
  error,
}) => {
  const [titleHeadingId] = useState(() => getUniqueId('prompt-modal-title'));
  const Cancel = primary === 'cancel' ? Button : SecondaryButton;
  const Ok = primary === 'ok' ? Button : SecondaryButton;

  return (<Modal
    open={open}
    onClose={cancelPrompt}
    className={styles.container}
    ariaLabelledBy={title ? titleHeadingId : undefined}
  >
    {title ? <h2 id={titleHeadingId}>{title}</h2> : null}
    <FormError error={error} />
    {messages[message] ? React.createElement(messages[message], props) : <p>{message}</p>}
    <div className={styles.btnWrap}>
      <Cancel onClick={cancelPrompt}>{cancelButton}</Cancel>
      <Ok loading={loading} onClick={okPrompt}>{okButton}</Ok>
    </div>
  </Modal>);
};

PromptModal.propTypes = {
  message: PropTypes.node,
  okButton: PropTypes.string,
  cancelButton: PropTypes.string,
  title: PropTypes.string,
  open: PropTypes.bool,
  cancelPrompt: PropTypes.func,
  okPrompt: PropTypes.func,
  props: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.any,
  primary: PropTypes.oneOf(['cancel', 'ok']),
};

PromptModal.defaultProps = {
  message: 'Are you sure?',
  okButton: 'Ok',
  cancelButton: 'Cancel',
  title: null,
  primary: 'cancel',
};

export default connect(({ prompt }) => (prompt && prompt.info ? {
  open: true,
  message: prompt.info.message,
  okButton: prompt.info.okButton,
  cancelButton: prompt.info.cancelButton,
  title: prompt.info.title,
  props: prompt.info.props,
  primary: prompt.info.primary,
  loading: prompt.loading,
  error: prompt.error,
} : {
  open: false,
}), {
  okPrompt: okPromptAction,
  cancelPrompt: cancelPromptAction,
})(PromptModal);



// WEBPACK FOOTER //
// ./src/client/Components/PromptModal/PromptModal.js